import { TbArrowLeft, TbArrowRight } from 'react-icons/tb'
import './MissionMediaSlide.sass'
import { useEffect, useState } from 'react';
import Loading from 'src/hci/common/Loading/Loading';

function MissionMediaSlide({ mediaList }) {
  const [currentItemIndex, setCurrentItemIndex] = useState(0);
  const currentItem = mediaList?.[currentItemIndex];

  const handlePrev = () => {
    if(currentItemIndex === 0) {
      setCurrentItemIndex(mediaList?.length - 1);
    } else {
      setCurrentItemIndex(currentItemIndex - 1);
    }
  }

  const handleNext = () => {
    if(currentItemIndex === mediaList?.length - 1) {
      setCurrentItemIndex(0);
    } else {
      setCurrentItemIndex(currentItemIndex + 1);
    }
  }

  return (
    <div className="mission-media-slide">
      <div className="slides-container">
        {['mp4'].includes(currentItem?.nameInfo?.extension) && (
          <video controls src={currentItem.url} />
        )}
        {['jpg', 'jpeg'].includes(currentItem?.nameInfo?.extension) && (
          <img src={currentItem?.url} alt={currentItem?.Key} />
        )}
        <div className="media-info">
          <div className="media-name">{currentItem?.nameInfo?.name}</div>
          <div className="right-section">
            <div className="media-counter">{`${currentItemIndex + 1} of ${mediaList?.length}`}</div>
          </div>
        </div>
        {mediaList?.length > 1 && (
          <>
            <div className="nav-button nav-button-prev" onClick={handlePrev}>
              <TbArrowLeft className='icon' />
            </div>
            <div className="nav-button nav-button-next" onClick={handleNext}>
              <TbArrowRight className='icon' />
            </div>
            {!currentItem && <Loading message="Loading media info" />}
          </>
        )}
      </div>
    </div>
  )
}

export default MissionMediaSlide